import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Background from "@/components/landing/Background";

/**
 * Single entry to /onboarding — routes user to the appropriate step.
 */
export default function OnboardingRouter() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (loading || !user) return;
        if (!user.plan) {
            navigate("/pricing", { replace: true });
            return;
        }
        const step = user.onboarding_step || "1";
        if (step === "done") navigate("/dashboard", { replace: true });
        else if (step === "4") navigate("/onboarding/step-3", { replace: true });
        else navigate(`/onboarding/step-${step}`, { replace: true });
    }, [user, loading, navigate]);

    return (
        <div className="min-h-screen relative flex items-center justify-center">
            <Background />
            <div className="relative z-10 font-mono text-sm text-secondary-c">Завантаження…</div>
        </div>
    );
}
